import { ANOMALY_LABEL, DAY_TYPE_LABEL, GPS_RESULT_LABEL, INCIDENT_STATUS_LABEL, RECORD_STATUS_LABEL, REQUEST_STATUS_LABEL, type AnomalyCode, type IncidentStatus, type RecordStatus, type RequestStatus } from '@wulftime/core';
import { MapPin } from 'lucide-react';
import { Badge } from './ui';

const RECORD_COLOR: Record<RecordStatus, string> = { NOT_STARTED: 'slate', AUTO_STARTED: 'violet', WORKING: 'green', ON_BREAK: 'amber', FINISHED: 'blue' };
export const RecordStatusBadge = ({ status }: { status: RecordStatus }) => <Badge color={RECORD_COLOR[status] ?? 'slate'}>{status === 'AUTO_STARTED' ? 'Inicio automático' : RECORD_STATUS_LABEL[status]}</Badge>;

const INC_COLOR: Record<IncidentStatus, string> = { DRAFT: 'slate', SUBMITTED: 'blue', IN_REVIEW: 'violet', INFO_REQUESTED: 'amber', APPROVED: 'green', REJECTED: 'red', CLOSED: 'slate' };
export const IncidentStatusBadge = ({ status }: { status: IncidentStatus }) => <Badge color={INC_COLOR[status]}>{INCIDENT_STATUS_LABEL[status]}</Badge>;

const REQ_COLOR: Record<RequestStatus, string> = { PENDING: 'blue', INFO_REQUESTED: 'amber', APPROVED: 'green', REJECTED: 'red', CANCELLED: 'slate' };
export const RequestStatusBadge = ({ status }: { status: RequestStatus }) => <Badge color={REQ_COLOR[status]}>{REQUEST_STATUS_LABEL[status]}</Badge>;

const DAY_COLOR: Record<string, string> = { WORKDAY: 'slate', REST: 'slate', HOLIDAY: 'violet', CLOSURE: 'violet', VACATION: 'green', ABSENCE: 'amber', UNSCHEDULED: 'slate' };
export const DayTypeBadge = ({ dayType, label }: { dayType: string; label?: string | null }) => (
  <Badge color={DAY_COLOR[dayType] ?? 'slate'}>
    {DAY_TYPE_LABEL[dayType as keyof typeof DAY_TYPE_LABEL] ?? dayType}
    {label ? ` · ${label}` : ''}
  </Badge>
);

const GPS_COLOR: Record<string, string> = { VALID: 'green', OUTSIDE_ZONE: 'red', LOW_ACCURACY: 'amber', NO_CENTER: 'slate', UNAVAILABLE: 'amber', PERMISSION_DENIED: 'red', NOT_PROVIDED: 'amber', NOT_REQUIRED: 'slate' };
export const GpsBadge = ({ result, distance }: { result: string; distance?: number | null }) => (
  <Badge color={GPS_COLOR[result] ?? 'slate'}>
    <MapPin className="h-3 w-3" aria-hidden />
    {GPS_RESULT_LABEL[result as keyof typeof GPS_RESULT_LABEL] ?? result}
    {distance !== null && distance !== undefined ? ` · ${distance} m` : ''}
  </Badge>
);

const SEVERE: string[] = ['MISSING_CLOCK_IN', 'MISSING_CLOCK_OUT', 'OUTSIDE_ZONE', 'INCONSISTENT_EVENTS', 'LONG_SHIFT', 'AUTO_START_NO_PERSONAL_CLOCK', 'WORK_DURING_ABSENCE'];
export const AnomalyBadge = ({ code }: { code: string }) => <Badge color={SEVERE.includes(code) ? 'red' : code === 'EXCESS_HOURS' ? 'blue' : 'amber'}>{ANOMALY_LABEL[code as AnomalyCode] ?? code}</Badge>;
